import PropTypes from 'prop-types';
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import XFormSelect from "../../Utils/Form/XFormSelect/index.jsx";
import {useSelector} from "react-redux";
import {selectAuthData} from "../../../redux/selectors/auth.js";
import {
  useLazyRequestOrganizationsAdminQuery,
  useLazyRequestOrganizationsQuery
} from "../../../redux/api/organizations.js";
import {ORGANIZATION_TYPE} from "../../../Constants.js";
import {organizationQueryFilter} from "../../../QueryFilters/queries.js";
import {selectUserType} from "../../../redux/selectors/userType.js";

function ProviderSelectForm({readOnly = false, providerOrg, currentOrganizationId }) {
  const {t} = useTranslation();
  const {user: {id: userId}} = useSelector(selectAuthData);
  const providerFilter = organizationQueryFilter(ORGANIZATION_TYPE.PROVIDER);

  const { isSuperAdmin, isAdmin } = useSelector(selectUserType);
  const [providers, setProviders] = useState(null);
  const [requestOrganizations] = useLazyRequestOrganizationsQuery();
  const [requestAdminOrganizations] = useLazyRequestOrganizationsAdminQuery();

  useEffect(() => {
    const providerOrganization = providerOrg?.find(
      (type) => type.name === ORGANIZATION_TYPE.PROVIDER
    );
    if (isSuperAdmin) {
      const providerFiltered = {
        ...providerFilter,
        where: { ...providerFilter.where, organizationTypeId: providerOrganization?.id }
      };
      requestOrganizations(JSON.stringify(providerFiltered)).then((response) => {
        setProviders(response.data);
      });
    } else if (isAdmin) {
      requestAdminOrganizations({ userId }).then((response) => {
        setProviders(response.data);
      });
    }
  }, [isSuperAdmin, isAdmin]);


  const providerOptions = useMemo(() => {
    return providers?.map((item) => {
      return {
        value: String(item.id),
        label: item.name
      }
    })
  }, [providers])

  return (
      <fieldset className='form__section'>
        <legend className='form__section-label form__section-label--3column'>
          <span>{t('providers')}</span>
        </legend>
        <XFormSelect
            readOnly={readOnly}
            id={'provider_id'}
            name={'provider_id'}
            hiddenBlankOption={false}
            disabledBlankOption={true}
            options={providerOptions}
            blankOptionValue=""
            placeholder={t('select_a_provider')}
            rules={{
              required: 'error_field_required'
            }}
        />
      </fieldset>
  );
}

export default ProviderSelectForm;

ProviderSelectForm.propTypes = {
  readOnly: PropTypes.bool
};

